import type { Platform } from "@kopi/platform";
import { createContext, type ReactNode, useContext } from "react";

const PlatformContext = createContext<Platform | null>(null);

export function PlatformProvider(props: { platform: Platform; children: ReactNode }) {
  return <PlatformContext.Provider value={props.platform}>{props.children}</PlatformContext.Provider>;
}

export function usePlatform(): Platform {
  const platform = useContext(PlatformContext);
  if (!platform) throw new Error("Platform runtime is not available");
  return platform;
}
